import styled from 'styled-components';
import { detectMobile } from '../../../utils/UiHelper';

export const CombosHintContainer = styled.div`
    height: 100%;
    min-height: ${detectMobile() ? '276px' : '276px'};
    width: 253px;
    min-width: 253px;
    padding: 16px 24px;
    text-align: left;
    box-sizing: border-box;
    border-radius: 4px;
    background: linear-gradient(223.44deg, #346aad 0%, #152c47 100%);
    /*margin: ${detectMobile() ? '0 0 0 16px' : '0'};*/
    position: relative;
`;
